import { InitialUserState } from '../datatypes/AppState';
import Cookies from 'universal-cookie';

//Set the expiry date of last visited url.
const lastVisitedUrlExpireDate = new Date();
lastVisitedUrlExpireDate.setDate(new Date().getDate() + 2);
const cookies = new Cookies();

export function setLastVistedUrl(url: any) {
  cookies.set('currentCookieUrl', url, {
    path: '/',
    expires: lastVisitedUrlExpireDate,
  });
}

export function getLastVisitedUrl() {
  return cookies.get('currentCookieUrl');
}

export const localStorageUtils = {
  getInitialUserState: (): InitialUserState | null => {
    const userStateStr: string | null = localStorage.getItem('userState');
    let userState: InitialUserState | null;
    if (userStateStr) {
      userState = JSON.parse(userStateStr);
    } else {
      userState = null;
    }
    return userState;
  },
  setLastVisitedPage: (pageCode: string) => {
    const userState = localStorageUtils.getInitialUserState();
    if (userState) {
      userState.lastAnsweredPage = pageCode;
      localStorageUtils.setInitialUserState(userState);
    }
  },
  setInitialUserState: (userState: InitialUserState) => {
    localStorage.setItem('userState', JSON.stringify(userState));
  },
  clearSesssionItems: () => {
    localStorage.removeItem('userState');
    localStorage.removeItem('attorney_registration_token');
    localStorage.removeItem('token_expiry');
    sessionStorage.clear();
  },
};
